import { render, staticRenderFns } from "./FormDesconto.vue?vue&type=template&id=52b34f1a&scoped=true&"
import script from "./FormDesconto.vue?vue&type=script&lang=js&"
export * from "./FormDesconto.vue?vue&type=script&lang=js&"
import style0 from "./FormDesconto.vue?vue&type=style&index=0&id=52b34f1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b34f1a",
  null
  
)

export default component.exports